import React, {
  useState,
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
} from "react";
import RadioBtn from "../../../../../Button/RadioBtn";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import FileUploadBtn from "../../../../../Button/FileUploadBtn";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import Flex from "../../../../../DefaultStyles/Flex";
import { FileNameBox } from "../../../../Benefit/Coupon/CouponPointRegisterModal/MassiveRegister";
import LineBtn from "../../../../../Button/LineBtn";
import { chatServerUrl, chatSocketUrl } from "../../RecentChatAll";
import axios from "axios";
import heic2any from "heic2any";
import useIsMobile from "../../../../../../hooks/useIsMobile";
import { Textarea } from "../../../../../Input/Textarea";
import Loader from "../../../../../DefaultStyles/Loader";
import { checkFword, encryptChat } from "../../../../../../ApiTS/web/ApiChatTS";
import moment from "moment";
import { autoSendCallTimer } from "../../../../../../Api/ApiChat";
import { IMessageData } from "../RecentChat";
import { GetStringByKeyValues } from "../../../../../../ApiTS/ApiTranslateTS";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";

const socketIo = io(`${chatSocketUrl}`, {
  reconnection: false,
  transports: ["websocket"],
});

interface SendChatModalProps extends DefaultModalCommonProps {
  targetUid: number;
  roomId: number;
  partyId: number;
  ownerUid: number;
  chatList: IMessageData[];
  setChatList: Dispatch<SetStateAction<IMessageData[]>>;
}

export default function SendChatModal({
  targetUid,
  closeEvent,
  roomId,
  partyId,
  ownerUid,
  chatList,
  setChatList,
}: SendChatModalProps) {
  const isMobile = useIsMobile();

  const [check, setCheck] = useState({
    image: false,
    text: false,
  });
  const [fileName, setFileName] = useState<undefined | string>(undefined);
  const [imgUrl, setImgUrl] = useState("");
  const [chat, setChat] = useState(""); // 채팅
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({
    413: false,
    common: false,
    exceedMsgCnt: false, // 하루 발신 메세지 초과
    exceedSize: false,
  });
  const [errorModal, setErrorModal] = useState({
    sleepTime: false, // 상대 방해 금지 시간
    exceedMsgCnt: false, // 하루 발신 메세지 초과
    fword: false,
  });
  const [fetchTargetInfo, setFetchTargetInfo] = useState(false);
  const [shortLink, setShortLink] = useState("");
  const [sentMessage, setSentMessage] = useState<IMessageData[]>([]);

  const encMsg =
    ownerUid === 1
      ? "나는채팅" + moment().format("DDHHYYYYMM") + "_1"
      : "나는채팅" + moment().format("DDHHYYYYMM") + "_3";
  const encOwnerSuperKey = encryptChat(encMsg);
  const encOwnerSuperKeyValueSid = "tbvjzl" + `${ownerUid}_` + encOwnerSuperKey;

  const isTargetSleepTime = false;

  const { response: targetResponse, error: targetError } = useApi({
    method: "get",
    url: fetchTargetInfo ? `user/info/${targetUid}` : undefined,
  });

  const sendSuccessEvent = () => {
    toast.success("메시지 전송을 완료했습니다.");
    closeEvent();
  };

  const uploadEmage = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.item(0)) {
      let file = e.target.files[0];
      const maxSize = 5 * 1024 * 1024; // 5MB

      const fileSize = file?.size;

      setFileName(file.name ?? "");

      if (fileSize > maxSize) {
        setError((prev) => ({
          ...prev,
          exceedSize: true,
        }));
        return;
      } else {
        setIsLoading(true);

        const sendImage = async () => {
          const formData = new FormData();
          formData.append("file", file); // formData는 키-밸류 구조
          formData.append("sid", encOwnerSuperKeyValueSid);
          formData.append("roomid", String(roomId));

          // 백엔드 multer라우터에 이미지를 보낸다.

          console.log(formData);

          try {
            const queryStr = `${chatServerUrl}/message/file`;

            const result = await axios.post(queryStr, formData, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            });

            console.log(result);

            if (result?.status === 201) {
              setIsLoading(false);

              const IMG_URL = `${result?.data}` ?? "";

              setImgUrl(IMG_URL);
              //   sendMessageEvent(IMG_URL);
            } else if (result?.status === 413) {
              // 이미지 용량 5MB 초과
              setIsLoading(false);
              setError((prev) => ({
                ...prev,
                413: true,
              }));
            } else {
              setIsLoading(false);
              setError((prev) => ({
                ...prev,
                common: true,
              }));
            }
          } catch (error) {
            setIsLoading(false);
            setError((prev) => ({
              ...prev,
              common: true,
            }));

            console.log(error);
          }
        };

        if (!isMobile && file?.name?.includes("heic")) {
          let blob = file;

          heic2any({ blob, toType: "image/jpg" }).then((result) => {
            console.log("✅", result);

            if (!Array.isArray(result)) {
              file = new File(
                [result],
                file?.name?.split(".heic")[0] + ".jpg",
                {
                  type: "image/jpeg",
                  lastModified: new Date().getTime(),
                }
              );

              console.log("✅", file);

              sendImage();
            }
          });
        } else {
          sendImage();
        }
      }
    }
  };

  // 채팅 보내기
  const sendMessage = async (imgUrl?: string) => {
    console.log(imgUrl);

    // 메세지 개수 체크
    // if (state?.cnt >= GetSystemSetData()?.MAX_MSGCNT) {
    //   setErrorModal({
    //     ...errorModal,
    //     exceedMsgCnt: true,
    //   });
    //   return;
    // } else

    {
      // 욕설 체크
      if (checkFword(chat)?.hasFword) {
        setErrorModal({
          ...errorModal,
          fword: true,
        });
      }

      setIsLoading(true);

      const queryStr = `${chatServerUrl}/message`;

      const encryptedChat = encryptChat(imgUrl ?? chat);

      const body = {
        sid: encOwnerSuperKeyValueSid,
        roomid: +roomId,
        message: encryptedChat,
        isRead: 0,
      };

      debugger;

      try {
        const response = await axios.post(queryStr, body);

        console.log(response);

        if (response?.status === 201) {
          const sentMessage = [response?.data?.message, ...chatList];

          setChatList(sentMessage); // 보낸 메세지 chatList로 업데이트 시켜주기
          setChat("");

          const myLastSentMsg = chatList?.find(
            (a) => a.writer === 1 || a.writer === 3
          );

          const now = moment().valueOf();
          const lastMsgTime = moment(myLastSentMsg?.date).valueOf();

          const checkTime = now - lastMsgTime;

          console.log(isTargetSleepTime, now, lastMsgTime, now - lastMsgTime);

          //   sendEvent();

          // 1. 방해 금지 시간 체크
          if (isTargetSleepTime) {
            setIsLoading(false);
            console.log("target sleep time");
            setErrorModal({
              ...errorModal,
              sleepTime: true,
            });
          }
          // 2. 호출 조건 체크: 내가 보낸 메세지가 없거나, 마지막 메세지와 현재 시간이 5분 이상이면 호출
          else if (checkTime === 0 || checkTime > autoSendCallTimer) {
            console.log("cannot calling");
            setFetchTargetInfo(true); // 파티원 정보 가져오기
            makeAutoCallLink(sentMessage); // 자동 호출 링크
          } else {
            setIsLoading(false);

            debugger;

            const message = {
              room: +roomId ?? 0,
              uid: ownerUid,
              message: encryptedChat,
              partyid: +partyId ?? 0,
            };

            socketIo.emit("sendMessage", message); // 메세지 보냈다고 서버에 알림
            console.log("message sent, need reloading!");
            sendSuccessEvent();
          }
        } else if (response?.status === 400) {
          setIsLoading(false);

          console.log(response);
        } else {
          setIsLoading(false);

          alert("채팅 보내기에 실패하였습니다.");
        }
      } catch (error) {
        setIsLoading(false);

        console.log(error);
      }
    }
  };

  // 자동 호출 링크 생성하기
  const makeAutoCallLink = async (sentMessage: IMessageData[]) => {
    axios({
      method: "post",
      url: "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyCzQSp5QOkud1dASwNinu6DlaAqhkJzfSk",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        dynamicLinkInfo: {
          link: `https://linkid.pw/myParty/${partyId}/PartyRoom?partyid=${partyId}&isHost=${true}`,
          iosInfo: {
            iosBundleId: "com.peachgrove.linkid",
            iosAppStoreId: "1553412232",
            iosIpadBundleId: "com.peachgrove.linkid",
            iosFallbackLink: `https://linkid.pw/myParty/${partyId}/PartyRoom?partyid=${partyId}&isHost=${true}`,
          },
          androidInfo: {
            androidPackageName: "com.peachgrove.linkid",
            androidFallbackLink: `https://linkid.pw/myParty/${partyId}/PartyRoom?partyid=${partyId}&isHost=${true}`,
          },
          domainUriPrefix: "https://linkidinvite.page.link",
          socialMetaTagInfo: {},
        },
      },
    }).then((res) => {
      if (res?.status === 200 && res?.data?.shortLink) {
        setShortLink(res?.data?.shortLink);
        setSentMessage(sentMessage);
      }
    });
  };

  // 호출하기
  const callEvent = async (shortLink: string, sentMessage: IMessageData[]) => {
    console.log(targetResponse);

    const receiverData = {
      nickname: targetResponse?.data?.nickname ?? "",
      uid: +targetResponse?.data?.uid ?? 0,
    };

    const encryptedSystemMsg = encryptChat(
      GetStringByKeyValues(80026, [
        { target: "{user_nick}", value: receiverData?.nickname ?? "" },
      ])
    );

    const body = {
      sid: encOwnerSuperKeyValueSid,
      recvuid: receiverData?.uid ?? 0,
      partyid: +partyId ?? 0,
      link: shortLink,
      roomid: +roomId ?? 0,
      message: encryptedSystemMsg,
    };

    const queryStr = `${chatServerUrl}/message/alarm`;
    try {
      const response = await axios.post(queryStr, body);

      if (response?.status === 201) {
        setShortLink("");
        setFetchTargetInfo(false);
        setIsLoading(false);
        console.log(sentMessage);
        const updateMessage = [response?.data?.message, ...sentMessage];
        console.log(updateMessage);

        setChatList(updateMessage); // 보낸 메세지 chatList로 업데이트 시켜주기
        sendSuccessEvent();
      } else {
        setIsLoading(false);

        alert("상대방 호출에 실패하였습니다.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (targetResponse?.status === 200 && shortLink?.length > 0) {
      callEvent(shortLink, sentMessage);
    }
  }, [targetResponse, shortLink, sentMessage]);

  useEffect(() => {
    if (targetError) {
      toast.error(targetError?.data ?? "파티원 정보를 가져올 수 없습니다.");
    }
  }, [targetError]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="채팅 보내기"
        isMediumModal={true}
        closeEvent={() => closeEvent()}
        confirmEvent={() => sendMessage(imgUrl !== "" ? imgUrl : undefined)}
        confirmDisabled={!check.image && !check.text}
      >
        <ModalRow style={{ alignItems: "flex-start" }}>
          <ModalLabel>
            <RadioBtn
              label="이미지 첨부"
              check={check?.image}
              noTooltip={true}
              clickEvent={() =>
                setCheck({
                  image: true,
                  text: false,
                })
              }
            />
          </ModalLabel>

          <div>
            <FileUploadBtn
              btnText="이미지 선택"
              btnColor="mint"
              onChangeEvent={uploadEmage}
              accept="image/*"
              isDisabled={check.text || !check.image}
            />

            {fileName && (
              <Flex style={{ marginTop: 10 }} gapSize={10}>
                <FileNameBox fileName={fileName}>{fileName}</FileNameBox>

                <LineBtn
                  btnText="삭제"
                  btnHeight={38}
                  btnClickEvent={() => {
                    setFileName(undefined);
                    setImgUrl("");
                  }}
                />
              </Flex>
            )}
          </div>
        </ModalRow>

        <ModalRow style={{ alignItems: "flex-start" }}>
          <RadioBtn
            label="메시지 입력"
            check={check?.text}
            noTooltip={true}
            clickEvent={() =>
              setCheck({
                image: false,
                text: true,
              })
            }
          />
        </ModalRow>

        <Textarea
          value={chat}
          onChange={(e) => setChat(e.target.value)}
          placeholder="메시지 직접 입력 (140자 이내)"
          disabled={check.image || !check.text}
        />
      </DefaultModalLayout>

      {isLoading && <Loader />}
    </>
  );
}
